import changeDeckStatus from '../../assets/setup/tutorial_change_deck_status.png';

export const EnableDisableDecks: React.FC = () => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <p>Enable or disable your decks within Deck Hopper.</p>
            {/* Mobile Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Mobile</h2>
                <ul className="list-disc list-inside">
                    <li>Long tap on a deck thumbnail while in a deck list to enable or disable it.
        <img className="mt-2 mb-3" src={changeDeckStatus} alt="Change deck status" width="300" />

                    </li>
                </ul>
            </div>

            {/* Desktop Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Desktop</h2>
                <ul className="list-disc list-inside">
                    <li>Right click on a deck thumbnail while in a deck list to enable or disable it.</li>
                </ul>
            </div>
        </div>
    );
};
